/* ===================================================================
   THE FLOAT CLUB — fc-popup.js
   Email capture for 20% off the first order.

   Design follows the PURE email build: deep water ground, cut-out dog,
   yellow CTA, mono eyebrow. Same family, different brand.

   Behaviour decisions worth stating, because most popups get these wrong:

   - It waits. 9 seconds, or exit intent on desktop, or 45% scroll. A
     popup that fires on load interrupts before there is anything to
     interrupt, and gets dismissed reflexively.
   - It shows ONCE. Dismissed or converted, it does not come back. That
     is stored per browser, so a returning visitor is left alone.
   - It never blocks the first paint, and never fires on checkout or
     the cart, where an interruption costs a sale rather than winning
     an address.
   - Escape closes it, the scrim closes it, and focus moves into it so
     keyboard users are not trapped behind it.

   Signups POST to Shopify's own /contact endpoint with the customer
   tagged for email marketing, which creates a real subscriber rather
   than a list this site has to hold.
=================================================================== */
(function (global) {
  "use strict";

  var KEY = "fc_popup_seen";
  var DELAY_MS = 9000;
  var SCROLL_TRIGGER = 0.45;
  var CODE = "FLOAT20";

  // never interrupt somebody who is already buying
  var path = location.pathname;
  if (/\/(checkouts?|cart|account)/.test(path)) return;
  try { if (localStorage.getItem(KEY)) return; } catch (e) {}

  var fired = false, el = null;

  function css() {
    var s = document.createElement("style");
    s.textContent = [
      /* shell */
      "#fc-pop{position:fixed;inset:0;z-index:400;display:none;align-items:center;justify-content:center;padding:18px}",
      "#fc-pop.on{display:flex}",
      "#fc-pop .scrim{position:absolute;inset:0;background:rgba(3,24,31,.64);backdrop-filter:blur(3px);",
      "opacity:0;transition:opacity .3s ease}",
      "#fc-pop.on .scrim{opacity:1}",

      /* card */
      "#fc-pop .box{position:relative;width:min(880px,100%);max-height:calc(100vh - 36px);overflow-y:auto;",
      "-webkit-overflow-scrolling:touch;border-radius:26px;background:#FFFDF8;",
      "box-shadow:0 40px 90px rgba(3,24,31,.42);display:grid;grid-template-columns:1.05fr 1fr;",
      "transform:translateY(16px) scale(.985);opacity:0;",
      "transition:transform .42s cubic-bezier(.16,.9,.2,1),opacity .32s ease}",
      "#fc-pop.on .box{transform:none;opacity:1}",

      /* art */
      "#fc-pop .art{position:relative;overflow:hidden;min-height:300px;",
      "background:linear-gradient(158deg,#2C7E92 0%,#0B4C5C 46%,#062A33 100%);",
      "display:flex;align-items:flex-end;justify-content:center}",
      "#fc-pop .art:after{content:\'\';position:absolute;left:50%;top:16%;width:330px;height:330px;",
      "transform:translateX(-50%);background:radial-gradient(circle,rgba(255,255,255,.16),transparent 66%)}",
      "#fc-pop .art img{position:relative;width:116%;max-width:none;display:block;margin-bottom:-5%;",
      "filter:drop-shadow(0 22px 44px rgba(0,0,0,.42))}",

      /* copy side */
      "#fc-pop .in{padding:clamp(24px,3.2vw,38px);display:flex;flex-direction:column;justify-content:center}",
      "#fc-pop .kick{font-family:\'JetBrains Mono\',monospace;font-size:10px;letter-spacing:.2em;",
      "text-transform:uppercase;color:#0B4C5C;margin-bottom:10px}",
      "#fc-pop .big{font-family:Anton,sans-serif;font-size:clamp(58px,7vw,84px);line-height:.84;",
      "color:#0B4C5C;letter-spacing:-.01em}",
      "#fc-pop .big em{font-style:normal;font-size:.44em;vertical-align:super;margin-left:2px;color:#FFC53D;-webkit-text-stroke:1px #0B4C5C}",
      "#fc-pop h2{font-family:Anton,sans-serif;font-size:clamp(20px,2.2vw,26px);line-height:1.02;",
      "text-transform:uppercase;color:#05222B;margin:6px 0 0}",
      "#fc-pop h2 span{color:#0B4C5C}",
      "#fc-pop p{font-size:13.5px;line-height:1.65;color:rgba(5,34,43,.78);margin:12px 0 18px}",
      "#fc-pop form{display:flex;flex-direction:column;gap:10px}",
      "#fc-pop input{height:52px;padding:0 16px;border-radius:14px;border:1px solid rgba(5,34,43,.16);",
      "background:#fff;color:#05222B;font-family:Archivo,sans-serif;font-size:16px;width:100%;box-sizing:border-box}",
      "#fc-pop input:focus{outline:3px solid #FFC53D;outline-offset:1px}",
      "#fc-pop button{min-height:54px;border:0;border-radius:999px;background:#FFC53D;color:#05222B;",
      "cursor:pointer;font-family:Archivo,sans-serif;font-weight:700;font-size:14px;letter-spacing:.04em;text-transform:uppercase}",
      "#fc-pop button:hover{background:#FFE08A}",
      "#fc-pop .fine{font-size:11px;line-height:1.6;color:rgba(5,34,43,.6);margin-top:12px}",
      "#fc-pop .x{position:absolute;top:10px;right:10px;width:40px;height:40px;border-radius:12px;border:0;",
      "background:rgba(255,255,255,.9);color:#05222B;cursor:pointer;font-size:20px;line-height:1;z-index:3;min-height:0}",

      /* success state */
      "#fc-pop .done{text-align:center}",
      "#fc-pop .code{font-family:Anton,sans-serif;font-size:32px;letter-spacing:.08em;color:#05222B;",
      "background:#FFC53D;display:inline-block;padding:12px 24px;border-radius:14px;margin:12px 0 4px}",
      "#fc-pop .go{display:block;margin-top:14px;text-align:center;text-decoration:none;background:#062A33;",
      "color:#EAF6F8;border-radius:999px;padding:17px;font-family:Archivo,sans-serif;font-weight:700;",
      "font-size:13px;letter-spacing:.04em;text-transform:uppercase}",

      /* MOBILE: stack. The art becomes a short banner with the face anchored
         to the top of it, so the eyes stay visible instead of being cropped
         off by a squat container. */
      "@media(max-width:760px){",
      "#fc-pop{padding:12px;align-items:flex-end}",
      "#fc-pop .box{grid-template-columns:1fr;max-width:460px;border-radius:22px;max-height:calc(100vh - 24px)}",
      "#fc-pop .art{min-height:0;height:190px;align-items:flex-start}",
      "#fc-pop .art img{width:74%;margin:0;margin-top:-2%}",
      "#fc-pop .art:after{top:-10%;width:260px;height:260px}",
      "#fc-pop .in{padding:22px 20px 24px}",
      "#fc-pop .big{font-size:56px}",
      "#fc-pop h2{font-size:19px}",
      "#fc-pop p{margin:10px 0 14px}",
      "#fc-pop .fine{font-size:10.5px}",
      "}",
      "@media(max-width:760px) and (max-height:680px){",
      "#fc-pop .art{height:130px}#fc-pop .big{font-size:46px}#fc-pop p{display:none}",
      "}"
    ].join("");
    document.head.appendChild(s);
  }

  function build() {
    var d = document.createElement("div");
    d.id = "fc-pop";
    d.setAttribute("role", "dialog");
    d.setAttribute("aria-modal", "true");
    d.setAttribute("aria-label", "20% off your first order");
    d.innerHTML =
      '<div class="scrim" data-close></div>' +
      '<div class="box">' +
        '<button class="x" data-close aria-label="Close">&times;</button>' +
        '<div class="art"><img src="https://cdn.shopify.com/s/files/1/0745/8501/4383/files/popup-dog-face.png?v=1785886946" alt="Dachshund resting his chin on the red Float Club vest"></div>' +
        '<div class="in" data-body>' +
          '<div class="kick">Heads up</div>' +
          '<div class="big">20<em>%</em></div>' +'<h2>off his<br><span>first vest.</span></h2>' +
          '<p>The chin float that holds his muzzle clear, and a handle to lift him out. ' +
          'Drop your email and the code is yours.</p>' +
          '<form data-form novalidate>' +
            '<input type="email" name="email" placeholder="you@email.com" autocomplete="email" required>' +
            '<button type="submit">Get my 20%</button>' +
          '</form>' +
          '<div class="fine">One email when there is something worth saying. Unsubscribe in one click. ' +
          'Code applies to your first order.</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(d);
    return d;
  }

  function open() {
    if (fired && el) { el.classList.add("on"); return; }
    fired = true;
    try { localStorage.setItem(KEY, "1"); } catch (e) {}
    css();
    el = build();
    requestAnimationFrame(function () { el.classList.add("on"); });
    var i = el.querySelector("input");
    if (i) setTimeout(function () { i.focus(); }, 380);
  }

  function close() {
    if (!el) return;
    el.classList.remove("on");
    setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); el = null; }, 340);
  }

  function succeed() {
    var body = el.querySelector("[data-body]");
    body.innerHTML =
      '<div class="done"><div class="kick">You are in</div>' +
      '<h2>Here is<br><span>your code.</span></h2>' +
      '<div class="code">' + CODE + '</div>' +
      '<p>20% off your first order. It is in your inbox too, in case this tab closes.</p>' +
      '<button type="button" data-addnow style="width:100%">Add a vest to my cart</button>' +
      '<a class="go" href="#product" data-close>Pick a colour first</a></div>';
  }

  document.addEventListener("click", function (e) {
    if (!e.target.closest) return;
    // straight into the cart from the success state, so a converted signup
    // does not have to go and find the product again
    if (e.target.closest("[data-addnow]")) {
      var add = document.querySelector('[data-m="sticky-add"], [data-add-to-cart]');
      close();
      if (add) setTimeout(function () { add.click(); }, 360);
      return;
    }
    if (e.target.closest("[data-close]")) close();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

  document.addEventListener("submit", function (e) {
    var f = e.target.closest ? e.target.closest("[data-form]") : null;
    if (!f) return;
    e.preventDefault();
    var email = (f.email.value || "").trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { f.email.focus(); return; }

    // Shopify's own newsletter endpoint: creates a real customer with email
    // marketing consent, so the segments already built pick them up.
    var fd = new FormData();
    fd.append("form_type", "customer");
    fd.append("utf8", "✓");
    fd.append("contact[email]", email);
    fd.append("contact[tags]", "newsletter,popup");
    fetch("/contact", { method: "POST", body: fd })
      .then(function () { succeed(); })
      .catch(function () { succeed(); });  // never trap them behind our error
  });

  // ---- triggers ---------------------------------------------------
  setTimeout(open, DELAY_MS);

  var onScroll = function () {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && window.scrollY / h > SCROLL_TRIGGER) { open(); window.removeEventListener("scroll", onScroll); }
  };
  window.addEventListener("scroll", onScroll, { passive: true });

  // exit intent, desktop only. A pointer leaving the top of the viewport
  // on a touch device means nothing.
  if (window.matchMedia("(min-width: 821px)").matches) {
    document.addEventListener("mouseout", function (e) {
      if (!e.relatedTarget && e.clientY <= 0) open();
    });
  }

  global.FC_POPUP = { open: open, close: close };

})(window);
